import { fetchDevices } from 'services/api/device/list';
import { getURLPathParams } from 'utils/URL';
import * as constants from './constants';

const initialize = () => dispatch => {
  dispatch({ type: constants.INITIALIZE });
  dispatch(fetchDevicesBegin());
  const urlParams = getURLPathParams();
  const showDevTools = urlParams.get('showDevTools') === 'true';
  dispatch(initializeSuccess({ showDevTools }));
};

const initializeSuccess = payload => dispatch => {
  dispatch({ type: constants.INITIALIZE_SUCCEEDED, payload });
};

const fetchDevicesBegin = () => async dispatch => {
  dispatch({ type: constants.FETCH });
  try {
    const {
      response: { devices },
    } = await fetchDevices();
    dispatch(fetchDevicesSuccess({ devices }));
  } catch (error) {
    dispatch(fetchDevicesFail({ error }));
  }
};

const fetchDevicesSuccess = payload => dispatch => {
  dispatch({ type: constants.FETCH_SUCCEEDED, payload });
};

const fetchDevicesFail = payload => dispatch => {
  dispatch({ type: constants.FETCH_FAILED, payload });
};

export {
  // action creators
  initialize,
  initializeSuccess,
  fetchDevicesBegin,
  fetchDevicesSuccess,
  fetchDevicesFail,
};
